// We don't want to include the contents of client.config.js in the production
// webpack build, as it will be modified by chef post-build.
//
// When this file is required server-side, it will use the values from
// client.config.js directly. When the file is required client-side,
// it will look for the values in __config global var that will be
// injected into HTML markup by the server.
module.exports = __CLIENT__ ? window.__config : require('./client.config');



// WEBPACK FOOTER //
// ./config/index.js